module.exports = __webpack_public_path__ + "img/icon-people.0d652553.svg";